import { Box } from '@mui/material'
import React from 'react'
import { useRouteError } from 'react-router-dom'

export const RouterError = ({ errorStatus }: { errorStatus?: number }) => {
    const error = useRouteError() as Error & { status?: number }
    const status = errorStatus || error?.status

    return (
        <>
            <Box style={{ textAlign: 'center' }} paddingBottom={20}>
                {status === 404 && (
                    <>
                        <h1>404 - Sidan kunde inte hittas</h1>
                        <p>Sidan du försökte nå kunde inte hittas.</p>
                    </>
                )}
                {status !== 404 && (
                    <>
                        <h1>Någonting gick fel</h1>
                        <p>Sidan kunde inte visas, försök igen senare.</p>
                    </>
                )}
            </Box>
        </>
    )
}
